import {Maybe} from '../../../graphql/generated/types';

export function isUnderAge14(age?: Maybe<number>): boolean {
  return !!age && age < 14;
}
